define('controllers/fieldRepeater',[ 'models/fieldRepeaterSetCollection', 'models/fieldCollection' ], function( repeaterSetCollection, fieldCollection ) {
    var controller = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( nfRadio.channel( 'repeater' ), 'init:model', this.initRepeater );
        },

        initRepeater: function ( model ) {
        	if ( 'undefined' == typeof model.collection.options.formModel ) {
        		return false;
        	}

        	// Ensure every sub-field has a key for data-testid rendering
        	var subFields = model.get( 'fields' );
        	if ( subFields && subFields.length ) {
        		_.each( subFields, function( field ) {
        			if ( ! field.key || '' === String( field.key ).trim() ) {
        				var d = new Date();
        				field.key = ( field.type || 'field' ) + '_' + d.valueOf();
        			}
        		});
        	}

        	let fields = new fieldCollection( subFields, { formModel: model.collection.options.formModel, repeaterFieldModel: model } );
            model.set( 'sets', new repeaterSetCollection( [ { fields: fields } ], { templateFields: model.get( 'fields' ), formModel: model.collection.options.formModel, repeaterFieldModel: model } ) );
            //Trigger Fields IDs sorting in case of same form being printed multiple times on DOM
            nfRadio.channel( "field-repeater" ).trigger( 'sort:fieldsets' );
        },

    });

    return controller;
});
